export var VIDEO_COOKIE = ['vuserid', 'vusession', 'main_login', 'video_platform'];
export var WXLOGIN_COOKIE = ['appid', 'openid', 'access_token', 'refresh_token', 'wx_nick', 'wx_head'];
export var PTLOGIN_COOKIE = ['encuin', 'luin', 'lskey', 'skey', 'qq_nick', 'qq_head'];
export var QQLOGIN_COOKIE = ['vqq_appid', 'vqq_openid', 'vqq_access_token', 'vqq_vuserid', 'vqq_vusession', 'qq_nick', 'qq_head']; // 汇总的视频票据

export var VIDEO_COOKIES = VIDEO_COOKIE.concat(WXLOGIN_COOKIE, QQLOGIN_COOKIE); // TV 登录态的 appid

export var TV_APPIDS = ['wx16c9bb0f25d540ae', 'wx7b9044085d71f4f5', 'wx97b828e706a2b420', '101161688', '101180898', '101226103', '101249687', '101254487', '101414262', '101439899'];